export const stripePriceToEuro = (price: number): string => {
    return new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" }).format(price / 100);
};

/**
 * Formats a number with thousand separators using German locale (dot as separator)
 * @param num The number to format
 * @returns Formatted number string with separator dots (e.g., "1.000")
 */
export const formatNumber = (num: number): string => {
    return new Intl.NumberFormat("de-DE").format(num);
};
